// extracted by mini-css-extract-plugin
module.exports = {"label":"TextField_label__16rTg","title":"TextField_title__2bGM0","value":"TextField_value__1ElE_"};